import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';
import { environment } from 'src/environments/environment';
import { SpecialRoutingService } from 'src/app/services/special-routing/special-routing.service';
import { UrlConstructorService } from 'src/app/services/url-constuctor/url-constructor.service';

@Component({
  selector: 'app-auth-screen',
  templateUrl: './auth-screen.component.html',
  styleUrls: ['./auth-screen.component.scss'],
})
export class AuthScreenComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly authService: RxAuthService,
    public readonly specialRoutingService: SpecialRoutingService,
    private readonly urlConstructorService: UrlConstructorService,
    public readonly router: Router
  ) {}

  ngOnInit(): void {
    this.handleRouteParams();
    this.authenticateUser();
  }

  /**
   * Handles route parameters and constructs a forward URL if valid keys are present.
   */
  private handleRouteParams(): void {
    this.route.queryParams.subscribe((params) => {
      if (Object.keys(params).length > 1) {
        // Check if the params contain "view", at least one "key", and at least one "value"
        const hasToken = Object.keys(params).includes("rx_token") || Object.keys(params).includes("wp_token");
        const hasView = Object.keys(params).includes("view");
        const hasKey = Object.keys(params).some((key) => key.includes("key"));
        const hasValue = Object.keys(params).some((key) => key.includes("value"));

        const properKeysPresent = hasToken && hasView && hasKey && hasValue;

        if (properKeysPresent) {
          const forwardURL = this.urlConstructorService.constructForwardURL(params);
          localStorage.setItem("forwardURL", forwardURL);
        } else {
          this.redirectToWPBase();
          console.warn("Required keys are missing in params.");
        }
      }
    });
  }
  /**
   * Authenticates the user based on tokens or redirects to appropriate base URLs.
   */
  private authenticateUser(): void {
    const rxToken = this.route.snapshot.queryParams['rx_token'];
    const wpToken = this.route.snapshot.queryParams['wp_token'];
    localStorage.removeItem('jwt_access');
    // console.log(rxToken)
    // console.log(wpToken)


    if (!rxToken && !wpToken) {

      this.redirectToWPBase();
      return;
    }


    if (rxToken) {
      this.authService.rx_login(rxToken);
    }
    else if (wpToken) {
      this.authService.rx_login(wpToken, true);
    }
  }

  /**
   * Redirects the user to a base URL depending on the referrer.
   * @param referrer The URL of the referring page.
   */
  private redirectBasedOnReferrer(referrer: string): void {
    if (referrer.startsWith(environment.raa.frontend_base)) {
      window.location.href = environment.raa.frontend_base;
    } else if (referrer.startsWith(environment.wp.frontend_base)) {
      this.redirectToWPBase()
    } else {
      this.redirectToWPBase();
    }
  }

  /**
   * Redirects the user to the default WordPress base URL.
   */
  private redirectToWPBase(): void {
    console.log('redirected to WP')
    window.location.href = `${environment.wp.frontend_base}/login`;
  }
}
